import IconBase from "react-icon-base";
import React from "react";

export default function Icon(props)  {
  return (
    <IconBase
      {...props}
      viewBox={"0 0 24 24"}
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="iso-8859-1"?>

<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 480.049 480.049" style="enable-background:new 0 0 480.049 480.049;" xml:space="preserve">
<g>
	<g>
		<rect x="464.022" y="16.051" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="448.022" y="0.052" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="432.022" y="16.051" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="448.022" y="32.051" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="400.022" y="16.051" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="384.022" y="176.051" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="416.022" y="176.051" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="400.022" y="160.051" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="400.022" y="192.051" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="88.032" y="152.051" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="72.032" y="136.051" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="56.022" y="152.051" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="72.032" y="168.051" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="24.022" y="152.051" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="0.027" y="48.051" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="32.022" y="48.051" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="16.022" y="32.051" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="16.022" y="64.051" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<rect x="112.032" y="0.052" width="16" height="16"/>
	</g>
</g>
<g>
	<g>
		<path d="M430.644,375.973c-3.401-9.565-12.466-15.946-22.618-15.922h-19.352l-28.648-50.128v-85.872c0-17.673-14.327-32-32-32
			v-104c1.623-46.978-35.144-86.377-82.122-88c-1.959-0.068-3.919-0.068-5.878,0c-55.008,0-86.4,45.184-88,87.696
			c0,0.104,0.056,0.2,0.056,0.304h-0.056v104c-17.673,0-32,14.327-32,32v85.872l-28.648,50.128H72.027
			c-13.224-0.027-23.966,10.67-23.994,23.894c-0.021,10.149,6.359,19.209,15.922,22.61c-11.555,13.061-10.334,33.017,2.728,44.572
			c4.72,4.176,10.583,6.844,16.832,7.66l155.432,21.192c0.72,0.094,1.448,0.094,2.168,0l155.432-21.192
			c17.292-2.259,29.479-18.108,27.22-35.4c-0.816-6.249-3.484-12.112-7.66-16.832C428.566,402.125,435.075,388.433,430.644,375.973z
			 M240.027,16.052c38-1.764,70.236,27.611,72,65.612c0.099,2.128,0.099,4.26,0,6.388h-16c-22.08-0.026-39.974-17.92-40-40
			c-0.001-4.418-3.583-7.999-8.002-7.998c-2.121,0-4.154,0.843-5.654,2.342c-19.833,19.909-45.621,32.802-73.448,36.72
			C173.322,43.168,203.81,16.127,240.027,16.052z M224.027,200.052v-34.216c5.215,1.43,10.593,2.175,16,2.216
			c5.41-0.046,10.79-0.808,16-2.264v34.264c0,4.418,3.582,8,8,8h16v10.232l-40,13.336l-40-13.336v-10.232h16
			C220.445,208.052,224.027,204.47,224.027,200.052z M177.563,93.804c23.753-4.394,46.029-14.66,64.8-29.864
			c7.065,23.756,28.88,40.062,53.664,40.112h3.488c-10,26.84-35.36,48-59.488,48C212.243,152.052,184.179,125.124,177.563,93.804z
			 M272.027,192.052v-32.68c17.662-9.94,31.679-25.272,40-43.752v76.432h-24H272.027z M168.027,115.644
			c8.271,18.519,22.3,33.872,40,43.776v32.632h-40V115.644z M184.027,208.052v16c0.003,3.442,2.206,6.496,5.472,7.584v0.008l48,16
			c1.643,0.552,3.421,0.552,5.064,0l48-16c3.265-1.091,5.466-4.149,5.464-7.592v-16h21.752l-36,144h-83.504l-36-144H184.027z
			 M195.707,368.052h88.64l32.144,37.496l-76.464,10.432l-76.464-10.4L195.707,368.052z M144.731,402.98l-14.76-2.008l50.12-55.696
			l3.2,12.712L144.731,402.98z M296.827,357.988l3.2-12.712l50.12,55.696l-14.792,2.008L296.827,357.988z M64.027,384.052
			c0-4.418,3.582-8,8-8h24c2.864,0.006,5.512-1.52,6.944-4l32-56c0.697-1.218,1.061-2.597,1.056-4v-88
			c0-6.535,3.975-12.414,10.04-14.848l14.672,58.68l14.664,58.68l-58.936,65.488h-44.44
			C67.608,392.052,64.027,388.47,64.027,384.052z M240.027,463.98L85.675,442.924c-8.638-1.141-14.715-9.068-13.574-17.706
			c1.04-7.873,7.769-13.745,15.71-13.71c0.712,0,1.423,0.051,2.128,0.152l56.888,7.76l90.4,12.328l42.824,26.768L240.027,463.98z
			 M394.379,442.924l-89.552,12.216l-41.832-26.144l70.176-9.6l56.88-7.76c8.633-1.211,16.612,4.806,17.823,13.439
			c0.103,0.734,0.154,1.475,0.153,2.217C407.999,435.172,402.183,441.833,394.379,442.924z M408.027,392.052h-44.44l-58.944-65.496
			l14.664-58.68l14.672-58.68c6.071,2.433,10.05,8.316,10.048,14.856v88c-0.005,1.403,0.359,2.782,1.056,4l32,56
			c1.432,2.48,4.08,4.006,6.944,4h24c4.418,0,8,3.582,8,8C416.027,388.47,412.445,392.052,408.027,392.052z"/>
	</g>
</g>
</svg>
`,
      }}
    />
  );
};
